import React, { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";
import LoadingIcon from "../../images/Loading_icon.gif";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExpertImage({
  proj_id,
  exp_id,
  exProfilePicture,
  setExProfilePicture,
}) {
  const { API_URL } = useContext(UrlContext);
  const [newUpload, setNewUpload] = useState(false);
  const dropArea = useRef(null);
  const galleryProfileRef = useRef(null);
  const progressBarRef = useRef(null);

  const [exProfilePictureLoading, setExProfilePictureLoading] = useState(false);
  const [exProfilePictureSuccess, setExProfilePictureSuccess] = useState(false);
  const [exProfilePictureError, setExProfilePictureError] = useState(false);

  const saveExProfilePicture = (imageURL) => {
    setExProfilePictureError(false);
    setExProfilePictureLoading(true);
    const url =
      `${API_URL}ppt-save-profile-picture-for-list/` + proj_id + "/" + exp_id;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ profilePicture: imageURL }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExProfilePictureLoading(false);
        if (data.status === "success") {
          setExProfilePictureSuccess(true);
          setTimeout(() => {
            setExProfilePictureSuccess(false);
            setExProfilePicture(data.file);
          }, 1500);
        } else {
          setExProfilePictureError(true);
        }
      })
      .catch((err) => {
        setExProfilePictureLoading(false);
        setExProfilePictureError(true);
      });
  };

  const handleProfileUploadClick = () => {
    $(".uploadProfile-popup-wrapper").fadeIn();
  };

  const handleProfileUploadCancel = () => {
    galleryProfileRef.current.innerHTML = `<img src="" id="exImage" style="display: none;">`;
    progressBarRef.current.value = 0;
    $(".uploadProfile-popup-wrapper").fadeOut();
  };

  const handleProfileUpload = () => {
    const exImageURL = galleryProfileRef.current.firstChild.src;
    if (exImageURL) {
      if (galleryProfileRef.current.childNodes.length === 2) {
        const exImageURL2 = galleryProfileRef.current.firstChild.src;
        // setExpertData({...expertData, profilePicture: exImageURL2});
        setExProfilePicture(exImageURL2);
        setNewUpload(false);
        saveExProfilePicture(exImageURL2);
      } else {
        // setExpertData({...expertData, profilePicture: exImageURL});
        setExProfilePicture(exImageURL);
        setNewUpload(false);
        saveExProfilePicture(exImageURL);
      }
    }
    galleryProfileRef.current.innerHTML = `<img src="" id="exImage" style="display: none;">`;
    progressBarRef.current.value = 0;
    $(".uploadProfile-popup-wrapper").fadeOut();
  };

  const preventDefaults = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    preventDefaults(e);
    dropArea.current.classList.add("highlight");
  };

  const handleDragOver = (e) => {
    preventDefaults(e);
  };

  const handleDragLeave = (e) => {
    preventDefaults(e);
    dropArea.current.classList.remove("highlight");
  };

  useEffect(() => {
    const dropAreaElement = dropArea.current;
    const preventDefaultEvents = (e) => {
      preventDefaults(e);
    };
    const highlight = (e) => {
      dropAreaElement.classList.add("highlight");
    };
    const unhighlight = (e) => {
      dropAreaElement.classList.remove("active");
    };
    const handleDrop = (e) => {
      preventDefaults(e);
      dropAreaElement.classList.remove("highlight");
      handleFiles(e);
    };
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      dropAreaElement.addEventListener(eventName, preventDefaultEvents, false);
      document.body.addEventListener(eventName, preventDefaultEvents, false);
    });
    ["dragenter", "dragover"].forEach((eventName) => {
      dropAreaElement.addEventListener(eventName, highlight, false);
    });
    ["dragleave", "drop"].forEach((eventName) => {
      dropAreaElement.addEventListener(eventName, unhighlight, false);
    });
    dropAreaElement.addEventListener("drop", handleDrop, false);
  }, []);

  const initializeProgress = (numFiles) => {
    progressBarRef.current.value = 0;
  };

  const updateProgress = (percent) => {
    progressBarRef.current.value = percent;
  };

  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type: "image/png" });
  };

  const handleFiles = async (e) => {
    console.log("here in handle");
    console.log(e);
    // console.log(e.dataTransfer.getData('text/html'))

    if (e.target.files) {
      let files = [...e.target.files];
      initializeProgress(e.target.files.length);
      files.forEach((file, index) => {
        previewFile(file);
      });
    } else if (e.dataTransfer.files.length > 0) {
      let files = [...e.dataTransfer.files];
      initializeProgress(e.dataTransfer.files.length);
      files.forEach((file, index) => {
        previewFile(file);
      });
    } else {
      const url = e.dataTransfer.getData("text/html");
      const parser = new DOMParser();
      const doc = parser.parseFromString(url, "text/html");
      const imgElement = doc.querySelector("img");
      // const match = /src=['"](data:image\/[^'"]+)['"]/i.exec(url);

      if (imgElement) {
        const imageURL = imgElement.getAttribute("src");
        if (imageURL.includes("data:image")) {
          const blob = dataURItoBlob(imageURL);
          const file = new File([blob], "image.png", { type: "image/png" });
          previewFile(file);
        } else {
          try {
            const response = await fetch(imageURL);
            if (response.ok) {
              const blob = await response.blob();
              const file = new File([blob], "image.png", { type: "image/png" });
              previewFile(file);
            } else {
              console.error("Failed to fetch image");
            }
          } catch (error) {
            console.error("Error fetching image:", error);
          }
        }
      }
    }
  };

  const previewFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      galleryProfileRef.current.innerHTML = `<img src="${reader.result}" id="exImage" />`;
      $("#exImage").show();
    };
  };

  return (
    <>
      <div className="position-relative">
        {exProfilePicture && !newUpload ? (
          <>
            <div className="preImg-div">
              <img
                src={`https://images.expertpowerhouse.com${exProfilePicture}`}
                id="profile-img"
                alt=""
              />
              <i
                id="img-rmvIcon"
                className="fa-solid fa-xmark"
                onClick={() => {
                  setNewUpload(true);
                  // setExpertData({...expertData, profilePicture: ''});
                  setExProfilePicture("");
                  saveExProfilePicture("");
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="icon-div" onClick={handleProfileUploadClick}>
              <i className="fa-solid fa-plus" />
            </div>
          </>
        )}
        {exProfilePictureLoading && (
          <img
            className="return-msg-icon"
            style={{ top: "0", right: "17px", height: "20px", width: "20px" }}
            src={LoadingIcon}
            alt="loading"
            title="Loading..."
          />
        )}
        {exProfilePictureSuccess && (
          <img
            className="return-msg-icon"
            style={{ top: "0", right: "17px", height: "20px", width: "20px" }}
            src={successIcon}
            alt="success"
            title="Success"
          />
        )}
        {exProfilePictureError && (
          <img
            className="return-msg-icon"
            style={{ top: "0", right: "17px", height: "20px", width: "20px" }}
            src={errorIcon}
            alt="error"
            title="Error! Please reload"
          />
        )}
      </div>

      {/*---------------------- upload expert's image popup -----------------------*/}
      <div className="uploadProfile-popup-wrapper">
        <div className="tab-pane fade show uploadProfile-div">
          <h4 className="mb-3">Upload Image</h4>
          <div className="row">
            <div
              ref={dropArea}
              id="drop-area-profile"
              onDragEnter={handleDragEnter}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={(e) => {
                preventDefaults(e);
                handleFiles(e);
              }}
            >
              <form className="my-form">
                <p>Drag &amp; Drop here.....</p>
                <input
                  type="file"
                  id="fileElem"
                  accept="image/*"
                  onChange={(e) => handleFiles(e)}
                />
                <label className="button-label" htmlFor="fileElem">
                  Select Expert's Image
                </label>
              </form>
              <progress
                id="progress-bar-profile"
                max={100}
                value={0}
                ref={progressBarRef}
              />
              <div
                id="gallery-profile"
                contentEditable="true"
                ref={galleryProfileRef}
              >
                <img src="" id="exImage" style={{ display: "none" }} alt="" />
              </div>
            </div>
          </div>
          <div>
            <center>
              <button
                type="button"
                className="btn btn-light"
                onClick={handleProfileUploadCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn base-btn"
                onClick={handleProfileUpload}
              >
                Update
              </button>
            </center>
          </div>
        </div>
      </div>
    </>
  );
}
